// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commercials-container {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  /* max-width: 900px; */
  margin: 0 auto;
}

.commercials-container h4 {
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.commercials-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
}

.commercials-table th,
.commercials-table td {
  border: 1px solid #e0e0e0;
  padding: 14px 18px;
  vertical-align: top;
}

.commercials-table th {
  background-color: #f0f4f8;
  color: #444;
  font-weight: 600;
  text-align: left;
}

.commercials-table td strong {
  color: #222;
}

.commercials-table ul {
  margin: 0;
  padding-left: 16px;
}

.commercials-table hr {
  margin: 10px 0;
  border: none;
  border-top: 1px dashed #ccc;
}

.commercials-table p {
  margin: 4px 0;
  font-size: 14px;
  color: #333;
}

@media (max-width: 768px) {
  .commercials-container {
    padding: 10px;
  }

  .commercials-table th,
  .commercials-table td {
    padding: 10px;
    font-size: 14px;
  }

  .commercials-container h4 {
    font-size: 18px;
  }
}

.nested-breakdown th,
.nested-breakdown td {
  text-align: center;
  vertical-align: middle;
  padding: 6px 8px;
  font-size: 13px;
}

.nested-breakdown {
  width: 100%;
  margin-bottom: 8px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.inner-scope-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.inner-scope-table th,
.inner-scope-table td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  text-align: center;
}

.inner-scope-table th {
  background-color: #f3f6f9;
  font-weight: 600;
  color: #333;
}

.inner-scope-table .total-row td {
  background-color: #e6f4ea;
  font-weight: bold;
  color: #2e7d32;
}

.overall-cost-row td {
  background-color: #e6ffe6; /* light green */
  font-size: 16px;
}

.invoice-filter-wrapper {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
  background-color: #f9fafb;
}

.filter-title {
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.invoice-filter-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  flex: 0 1 200px;
}

.filter-label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #444;
}

.filter-datepicker {
  padding: 6px 10px;
  font-size: 13px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.filter-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-btn {
  padding: 6px 14px;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  min-width: 100px;
  font-weight: 500;
}

.filter-btn.primary {
  background-color: #007bff;
  color: white;
}

.filter-btn.primary:disabled {
  background-color: #a8d0ff;
  cursor: not-allowed;
}

.filter-btn.secondary {
  background-color: #e4e4e4;
  color: #333;
}

.main-container{
  height : 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/CommercialsTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,4DAA4D;EAC5D,yCAAyC;EACzC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".commercials-container {\n  padding: 20px;\n  background-color: #f9f9f9;\n  border-radius: 10px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  /* max-width: 900px; */\n  margin: 0 auto;\n}\n\n.commercials-container h4 {\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.commercials-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #fff;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.commercials-table th,\n.commercials-table td {\n  border: 1px solid #e0e0e0;\n  padding: 14px 18px;\n  vertical-align: top;\n}\n\n.commercials-table th {\n  background-color: #f0f4f8;\n  color: #444;\n  font-weight: 600;\n  text-align: left;\n}\n\n.commercials-table td strong {\n  color: #222;\n}\n\n.commercials-table ul {\n  margin: 0;\n  padding-left: 16px;\n}\n\n.commercials-table hr {\n  margin: 10px 0;\n  border: none;\n  border-top: 1px dashed #ccc;\n}\n\n.commercials-table p {\n  margin: 4px 0;\n  font-size: 14px;\n  color: #333;\n}\n\n@media (max-width: 768px) {\n  .commercials-container {\n    padding: 10px;\n  }\n\n  .commercials-table th,\n  .commercials-table td {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .commercials-container h4 {\n    font-size: 18px;\n  }\n}\n\n.nested-breakdown th,\n.nested-breakdown td {\n  text-align: center;\n  vertical-align: middle;\n  padding: 6px 8px;\n  font-size: 13px;\n}\n\n.nested-breakdown {\n  width: 100%;\n  margin-bottom: 8px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n}\n\n.inner-scope-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.inner-scope-table th,\n.inner-scope-table td {\n  border: 1px solid #ccc;\n  padding: 6px 8px;\n  text-align: center;\n}\n\n.inner-scope-table th {\n  background-color: #f3f6f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.inner-scope-table .total-row td {\n  background-color: #e6f4ea;\n  font-weight: bold;\n  color: #2e7d32;\n}\n\n.overall-cost-row td {\n  background-color: #e6ffe6; /* light green */\n  font-size: 16px;\n}\n\n.invoice-filter-wrapper {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n  background-color: #f9fafb;\n}\n\n.filter-title {\n  margin-bottom: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.invoice-filter-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: flex-end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 200px;\n}\n\n.filter-label {\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #444;\n}\n\n.filter-datepicker {\n  padding: 6px 10px;\n  font-size: 13px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.filter-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.filter-btn {\n  padding: 6px 14px;\n  font-size: 13px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  min-width: 100px;\n  font-weight: 500;\n}\n\n.filter-btn.primary {\n  background-color: #007bff;\n  color: white;\n}\n\n.filter-btn.primary:disabled {\n  background-color: #a8d0ff;\n  cursor: not-allowed;\n}\n\n.filter-btn.secondary {\n  background-color: #e4e4e4;\n  color: #333;\n}\n\n.main-container{\n  height : 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
